// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"167a6f1b","561":"d5afd0c8"}[chunkId] + ".chunk.css";
};